import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTruncatedText } from "@/hooks/useTruncatedText";

interface TruncatedTextWithTooltipProps {
  text: string;
  children: (props: {
    ref: React.RefObject<HTMLElement>;
    isTruncated: boolean;
  }) => React.ReactElement;
  className?: string;
}

/**
 * Componente que adiciona tooltip automaticamente quando o texto está truncado
 */
export function TruncatedTextWithTooltip({
  text,
  children,
  className,
}: TruncatedTextWithTooltipProps) {
  const { ref, isTruncated } = useTruncatedText();

  // Se o texto não está truncado, renderiza apenas o children sem tooltip
  if (!isTruncated) {
    return children({ ref, isTruncated });
  }

  // Se o texto está truncado, envolve com tooltip
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {children({ ref, isTruncated })}
        </TooltipTrigger>
        <TooltipContent className={className}>
          <p>{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
